import { serviceMaker, methods, api } from "./index.js";

export const getTicketCustomer = () =>
  serviceMaker(`/tickets/alltickets?type=Customer`, methods.GET, api.NGB);
export const getTicketTemplate = () =>
  serviceMaker(`/tickets/template`, methods.GET, api.NGB);
export const getCustomerSearch = (type, statusType, fromDate, toDate) =>
  serviceMaker(
    `/tickets/alltickets?type=${type}&statusType=${statusType}&fromDate=${fromDate}&toDate=${toDate}`,
    methods.GET,
    api.NGB
  );
  export const getFeedbackTemplate = () =>
  serviceMaker(`/feedback-campaign/tickets`, methods.GET, api.NGB);
export const getEscalatedCustomerTickets = (id) =>
  serviceMaker(`/tickets/customer/escalate/${id}`, methods.PUT, api.NGB);
export const getEscalatedOfficeTickets = (id) =>
  serviceMaker(`/tickets/office/escalate/${id}`, methods.PUT, api.NGB);
export const getTicketSubCategory = (id) =>
  serviceMaker(`/subcategory/byCategory?category=${id}`, methods.GET, api.NGB);
